import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { AdminInviteParams } from '~/types/integrations';

export const integrations = createQueryKeys('integrations', {
  keys: null,
  invites: (params: AdminInviteParams) => [params],
  signupInvite: (code: string) => [code],
});
